import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useCurrentUser } from '@savgroup-front-common/core/domains/login/useLoginStore';
import {
  storeActionCreators,
  storeSelectors,
} from '@savgroup-front-common/core/domains/store';

import { useControlTypedSelector } from '@/hooks';

const useStore = () => {
  const dispatch = useDispatch();
  const { assignedStoresIds: storeIds } = useCurrentUser();
  const stores = useControlTypedSelector((state) =>
    storeSelectors.selectStoreByIds(state, { storeIds }),
  );

  useEffect(() => {
    storeIds.forEach((storeId) =>
      dispatch(storeActionCreators.getStore({ storeId })),
    );
  }, [dispatch, storeIds]);

  return stores.map(({ name }) => name);
};

export default useStore;
